export default "__VITE_ASSET__eqkStWdt__"